import { ENDPOINT } from "./Application"
const math = require('mathjs')
import Two from "two.js";


export class Point{
    x: number
    y: number
    constructor(x, y){
        this.x = x
        this.y = y
    }

    dist(other? : Point){
        let dx = (this.x - (other?.x || 0))
        let dy = (this.y - (other?.y || 0))
        return Math.sqrt(dx * dx + dy * dy)
    }

    normalize(){
        let d = this.dist()
        this.x = (this.x / d) || 0
        this.y = (this.y / d) || 0
    }
}

const positiveMod = (e, m) => {return ((e % m) + m) % m} 
export const lerp = ((x1, x2, t) => ((x2 - x1) * t + x1))
export const anglerp = ((x1, x2, t) => (positiveMod(x2 - x1 + Math.PI, 2*Math.PI) - Math.PI)*t + x1)

export function colorShape (shape, fill="orange", stroke="orangered"){
    shape.fill = fill
    shape.stroke = stroke
    return shape
}

const C = Two.Circle
const R = Two.Rectangle
const P = Two.Polygon
const Po = Two.Anchor
const Pa = Two.Path
// var safeEval = require('safe-eval')

export function parseSpriteCode(s){
    // ! separated list of tuples; first element defines shape (C=circle, R=rectangle, etc..), second/third element define fill/stroke
    // !(C(0, 0, 10), 'red', 'red')!....
    return new Two.Group(eval('[' + s.replace(')!', '),!').replace('!(', 'colorShape(new ') + ']') )
}


export const projData = {}

export async function fetchProjData(){
    var res = await fetch(ENDPOINT + '/projectileData');
    Object.assign(projData, await res.json())
    console.log(projData)
}

const factorialCache = [1];
for (var i = 1; i < 50; i++){
    factorialCache.push(factorialCache[i-1] * i)
}

function perm(c, x){
    if (x > c){
        return 0
    }
    return factorialCache[c] / factorialCache[c - x]
}

class Polynomial{
    coeffs : number[];
    constructor(coeffs){
        this.coeffs = coeffs
    }

    eval(t, d=0){
        var sum = 0
        this.coeffs.forEach((e, i) => {
            sum += (perm(i, d) * Math.pow(t, i - d)) || 0
        })
        return sum
    }
}

export const timeScale: number = 50 //ms
export class EntityMotion{
    x: number
    y: number
    speed: number
    speedAngle: number
    clientTime: number
    serverTime: number

    get vx(){
        return Math.cos(this.speedAngle) * this.speed * timeScale * 60 / 1000
    }

    get vy(){
        return Math.sin(this.speedAngle) * this.speed * timeScale * 60 / 1000
    }

    static fromEntity(entity, time){
        return Object.assign(new EntityMotion(), {x: entity.x, y: entity.y, speed: entity.speed, speedAngle: entity.speedAngle},
            {clientTime: performance.now() + performance.timeOrigin, serverTime: time}
        )
    }
}

export class Interpolator{
    basis: Polynomial[];
    coeffs: math.Matrix;
    reg: number

    tmin: number
    tmax: number

    startVals;  
    endVals;
    coeffBase;

    exLim = 10;
    startT;
    first; 
    second;

    constructor(basis, reg?){
        this.basis = basis
        this.reg = reg ?? 0
    }

    evalMat(ts, d=1){
        return math.transpose(math.matrix(this.basis.map((poly) => {
            let arr = []
            for (var tt of ts){
                for (var dd = 0; dd < d; dd++){
                    arr.push(poly.eval(tt, dd))
                }
            }
            return arr
        })))
    }

    interpolate(ts, xs, ys, ws?){
        // xs is [[v_t0, v_t0', v_t0''.....], [...], ...]
        var d = xs[0].length
        this.startVals = [xs[0], ys[0]]
        this.endVals = [xs[ts.length - 1], ys[ts.length - 1]]
        var arr = [xs, ys]
        var mat = this.evalMat(ts, d)

        var coeffBase = [...Array(this.basis.length)].map((e) => {return [0, 0]})
        coeffBase[0] = [xs[0][0], ys[0][0]]
        coeffBase[1] = [xs[0][1], ys[0][1]]
        this.coeffBase = coeffBase

        ws = ws ? math.matrix(ws).resize([ws.length, 1]) : math.ones(mat.size()[0], 1)
        mat = math.dotMultiply(mat, ws)
        arr = math.transpose(math.matrix(arr.map((e) => {return e.flat()})))
        arr = math.subtract(arr, math.multiply(mat, coeffBase))

        var res = math.multiply(math.transpose(mat), math.dotMultiply(arr, ws))
        var mtm = math.add(math.multiply(math.transpose(mat), mat), math.multiply(math.identity(this.basis.length), this.reg))
        this.coeffs = math.add(math.multiply(math.inv(mtm), res), coeffBase)
        this.tmin = ts[0]
        this.tmax = ts[ts.length - 1]
    }

    toT(t){
        return (t - this.first.serverTime) / timeScale
    }

    interpolateMotion(m1, m2, ws?){
        // this.startT = m1.serverTime
        if ((m1 == this.first) && (m2 == this.second)){
            return
        }
        this.first = m1
        this.second = m2
        this.interpolate([this.toT(m1.serverTime), this.toT(m2.serverTime)], 
                         [[m1.x, m1.vx], [m2.x, m2.vx]], 
                         [[m1.y, m1.vy], [m2.y, m2.vy]], ws)
    }

    eval(_t, d=1){
        let t = this.toT(_t)
        if (t > this.tmax){
            var [[x, speedX], [y, speedY]] = this.endVals;
            x = x + speedX * Math.min(this.exLim, t - this.tmax)
            y = y + speedY * Math.min(this.exLim, t - this.tmax)
            if (t - this.tmax < this.exLim){
                console.log('E')
            }
            if (d == 1){
                return math.matrix([[x, y]])
            }
            return math.matrix([[x, y], [speedX, speedY]])
        }
        if (t < this.tmin || (!this.coeffs)){
            var [[x, speedX], [y, speedY]] = this.startVals;
            if (d == 1){
                return math.matrix([[x, y]])
            }
            return math.matrix([[x, y], [speedX, speedY]])
        }

        var mat = this.evalMat([t], d)
        var res = math.multiply(mat, this.coeffs).valueOf()
        
        res[0] = res[0].map((e, i) => clamp(e, Math.min(this.startVals[i][0], this.endVals[i][0]), Math.max(this.startVals[i][0], this.endVals[i][0])))
        console.log('I')
        return math.matrix(res)
    }
}

export const posV = (t) => [...Array(4).keys()].map((i) => {return Math.pow(t, i)})
export const speedV = (t) => [...Array(4).keys()].map((i) => {return (i * Math.pow(t, i - 1)) || 0})
export const clamp = (x, mi, ma) => {return Math.min(Math.max(mi, x), ma)}
export const chebyshevPolys = [[1], [0, 1], [-1, 0, 2], [0, -3, 0, 4], [1, 0, -8, 0, 8]].map((e) => {return new Polynomial(e)})

export const bitmask = {'w': 1, 'a': 2, 's': 4, 'd': 8}
const coords = {0: [0, 0], 1: [0, -1], 2: [-1, 0], 4: [0, 1], 8: [1, 0]}
export const angleCache = {}
for (var i = 0; i < 16; i++){
    var [totX, totY] = [0, 0]
    for (var j = 1; j <= 8; j <<= 1){
        var [x, y] = coords[i & j]
        totX += x
        totY += y
    }
    angleCache[i] = Math.atan2(totY, totX) || 0
}